import React, { useMemo, ReactElement } from 'react';
import FilterContainer from '../../../../components/filter-container/filter-container.component';
import FilterSelectField from '../../../../components/filter-select-field/filter-select-field.component';
import MenuItemList from '../../../../components/menu-item-list/menu-item-list.component';
import { ACTIVE_TYPE_LIST } from '../../../../constants/system/active-types';
import { FILTER_VALUE_EMPTY } from '../../../../constants/system/filter-values';
import {
  FILTER_TYPE_ACCOUNT_USER_TYPE, FILTER_TYPE_ACTIVE, FILTER_TYPE_ROLE, FILTER_TYPE_COMPANY_ID,
} from '../../../../constants/system/filter-types';
import CompanyDefaultImage from '../../../../static/images/company-default-image.png';

const SettingsUserListFilters: ReactMemoComponent = React.memo((props: ReactComponentProps): ReactElement => {
  const {
    filters,
    currentFilters,
    filterAccountUserTypeList,
    filterRoleList,
    filterContactCompanyList,
    onSetFilterValue,
  } = props;

  const filterAccountUserType: string = filters && filters[FILTER_TYPE_ACCOUNT_USER_TYPE];
  const filterActive: boolean = filters && filters[FILTER_TYPE_ACTIVE];
  const filterRole: string = filters && filters[FILTER_TYPE_ROLE];
  const filterContactCompanyId: number = filters && filters[FILTER_TYPE_COMPANY_ID];

  const menuItemFilterAccountUserTypeList: ReactElement[] = useMemo((): ReactElement[] => MenuItemList({
    optionItemValueKey: 'name',
    optionList: filterAccountUserTypeList,
    selectedValue: filterAccountUserType,
  }), [filterAccountUserTypeList, filterAccountUserType]);

  const menuItemFilterActiveTypeList: ReactElement[] = useMemo((): ReactElement[] => MenuItemList({
    optionItemValueKey: 'name',
    optionList: ACTIVE_TYPE_LIST,
    selectedValue: filterActive,
  }), [filterActive]);

  const menuItemFilterRoleList: ReactElement[] = useMemo((): ReactElement[] => MenuItemList({
    optionItemValueKey: 'name',
    optionList: filterRoleList,
    selectedValue: filterRole,
  }), [filterRoleList, filterRole]);

  const menuItemFilterContactCompanyList: ReactElement[] = useMemo((): ReactElement[] => MenuItemList({
    withImage: true,
    isExtended: true,
    optionItemLabelKey: 'fullName',
    optionList: filterContactCompanyList,
    defaultImage: CompanyDefaultImage,
    selectedValue: filterContactCompanyId,
  }), [filterContactCompanyList, filterContactCompanyId]);

  return (
    <FilterContainer>
      <FilterSelectField
        filterType={FILTER_TYPE_ACCOUNT_USER_TYPE}
        label="Type"
        value={currentFilters[FILTER_TYPE_ACCOUNT_USER_TYPE] || FILTER_VALUE_EMPTY}
        currentFilters={currentFilters}
        menuItemList={menuItemFilterAccountUserTypeList}
        onSetFilterValue={onSetFilterValue}
      />
      <FilterSelectField
        filterType={FILTER_TYPE_ACTIVE}
        label="Active"
        value={currentFilters[FILTER_TYPE_ACTIVE] || currentFilters[FILTER_TYPE_ACTIVE] === false
          ? currentFilters[FILTER_TYPE_ACTIVE] : FILTER_VALUE_EMPTY}
        currentFilters={currentFilters}
        menuItemList={menuItemFilterActiveTypeList}
        onSetFilterValue={onSetFilterValue}
      />
      <FilterSelectField
        filterType={FILTER_TYPE_ROLE}
        label="Role"
        value={currentFilters[FILTER_TYPE_ROLE] || FILTER_VALUE_EMPTY}
        currentFilters={currentFilters}
        menuItemList={menuItemFilterRoleList}
        onSetFilterValue={onSetFilterValue}
      />
      <FilterSelectField
        isInteger
        filterType={FILTER_TYPE_COMPANY_ID}
        label="Company"
        value={currentFilters[FILTER_TYPE_COMPANY_ID] || FILTER_VALUE_EMPTY}
        currentFilters={currentFilters}
        menuItemList={menuItemFilterContactCompanyList}
        onSetFilterValue={onSetFilterValue}
      />
    </FilterContainer>
  );
});

export default SettingsUserListFilters;
